import { Filter } from "./filter";

export class ByDepartment extends Filter {
  constructor(public id?: number) {
    super("by.department");
  }
}
